import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import TableCustomViewOptionsStore from "csi/middleware/customView/options/TableCustomViewOptionsStore";
import { ComponentItem } from "designSystem/types/component-item-types";
import { action, computed, makeObservable } from "mobx";
import { ChangeEvent, FunctionComponent } from "react";
import { ICustomViewSecondaryDisplayDropDownOptions, ICustomViewSecondaryDisplayOptions, SecondaryDisplayType } from "./CustomViewSecondaryDisplayOptions";

/**
 * This store contains information about Secondary display options
 */
class SecondaryDisplayCustomViewOptionsStore extends TableCustomViewOptionsStore<ICustomViewSecondaryDisplayOptions> {
	/** all the dropdown boxes selection options for the custom view */
	readonly secondaryDisplayDropDownOptions: ICustomViewSecondaryDisplayDropDownOptions;

	constructor(
		secondaryDisplayDropDownOptions: ICustomViewSecondaryDisplayDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: ICustomViewSecondaryDisplayOptions,
	) {
		super(secondaryDisplayDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
		this.secondaryDisplayDropDownOptions = secondaryDisplayDropDownOptions;
	}

	@action onChangeSecondaryDisplayType = (event: ChangeEvent<{}>, value: ComponentItem): void => {
		this.options.secondaryDisplayType = value.id as SecondaryDisplayType;
	};
	
	@computed get selectedSecondaryDisplayType(): ComponentItem {
		const { secondaryDisplayType } = this.options;
		return this.secondaryDisplayDropDownOptions.secondaryDisplayTypeOptions.find((item) => item.id === secondaryDisplayType);
	};
}

export = SecondaryDisplayCustomViewOptionsStore;